import { Component, Input, OnInit } from '@angular/core';
import { VoxelAutocompleteComponent } from '@voxel/components';
import { getValueProperty } from '../../shared/helpers/functions.helpers';

@Component({
  selector: 'app-clean-autocomplete',
  templateUrl: './clean-autocomplete.component.html',
  styleUrls: ['./clean-autocomplete.component.scss']
})
export class CleanAutocompleteComponent implements OnInit {

  @Input() autocomplete!: VoxelAutocompleteComponent;
 
  constructor() { }

  ngOnInit(): void {
  }

  get valueFilter(){
    return getValueProperty(this.autocomplete, 'input.viewValue');
  }

  cleanFilter() {
    this.autocomplete.setValue(null);
    this.autocomplete.resetValue();
    this.autocomplete.resetSelection();
  }

  openList(){
    this.autocomplete.panelOpen = true;
  }

}
